import React from 'react';
import A, { AnchorProps } from '@sls-react/components/Links/A';

type Props = AnchorProps & { href?: string };

const NewTabLink: React.FC<Props> = ({ children, rel, ...props }) => (
  <A
    {...props}
    target="_blank"
    rel={`noopener noreferrer${rel ? ' ' + rel : ''}`}
  >
    {children}
  </A>
);

export default NewTabLink;
